import lazyWithRetry from 'tools/lazyWithRetry';

const component = lazyWithRetry(() => import(
	/* webpackChunkName: "InsuranceContractListPage" */
	'pages/vehicle/InsuranceContract/InsuranceContractListPage'));

export default [{ component, exact: true, path: '/insurance_contracts' }];